import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="w-full text-center py-4 absolute bottom-0 left-0 z-50 text-gray-500 text-sm opacity-80">
      © {new Date().getFullYear()} Digital Ladyland. All rights reserved.
      <span className="mx-2">|</span>
      <Link to="/privacy" className="underline hover:text-white">
        Privacy Policy
      </Link>
      <span className="mx-2">|</span>
      <a href="mailto:support@digitalladyland.com" className="underline hover:text-white">
        Support
      </a>
    </footer>
  );
}

export default Footer;
